// imove-behavior: 遍历数组依次上报

export default async function(ctx) {
  const cacheDataReportTask = ctx.payload?.cacheDataReportTask || [];
  const { webReport } = ctx.getPipe();
  if (cacheDataReportTask?.length) {
    cacheDataReportTask.forEach((task) => webReport.dataReport(task.eventName, task.reportObj));
  }
  return ctx.getPipe();
}